import { CustomResponse } from '@/models/custom-response.model';
import { CustomUser } from '@/models/custom-user.model';
import { AuthenticationService } from '@/services';
import { UserService } from '@/services';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { AuthenticationState } from './types';


export const actions: ActionTree<AuthenticationState, RootState> = {
    login({ dispatch, commit }: any, { email, password }: { email: string, password: string }) {

        return new Promise((resolve, reject) => {
            commit('loginRequest', { email });

            AuthenticationService.login(email, password)
                .then((response: CustomUser) => {
                    commit('loginSuccess', response);
                    resolve();
                })
                .catch((error: CustomResponse<any>) => {
                    commit('loginFailure', error);
                    dispatch('notification/addError', error && error.localized, { root: true });
                    reject();
                });
        });
    },
    logout({ commit }: any) {
        return new Promise((resolve) => {
            AuthenticationService.logout();
            commit('logoutSuccess');
            resolve();
        });
    },
    update({ dispatch, commit }: any, user: CustomUser) {

        return new Promise((resolve, reject) => {
            commit('updateUserRequest', user);

            UserService.updateMe(user)
                .then((response: CustomResponse<CustomUser>) => {
                    commit('updateUserSuccess', response.data);
                    resolve();
                })
                .catch((error: CustomResponse<any>) => {
                    commit('updateUserFailure', error);
                    dispatch('notification/addError', error && error.localized, { root: true });
                    reject();
                });
        });
    },
};
